<template>
  <div id="app">
    <router-view v-if="pc"></router-view>
    <router-view name="mobile" v-else></router-view>
  </div>
</template>

<script>

import mobileView from "@/components/mobileView";
import pcView from "@/components/pcView"
import VueRouter from 'vue-router'
import './utils/hd'
import './css/normalize.css'
import Yxmh from './components/yanxidamiaohui'
import jnmhPC from "@/components/jnmhPC";


const router= new VueRouter({
  routes: [

    {
      path: '/',
      components:{
        default: pcView,
        mobile: mobileView
      }
    },
    {
      path: '/yxmhPC',
      components: {
        default: Yxmh,
        mobile: Yxmh
      }
    },
    {
      path: '/jnmhPC',
      components: {
        default: jnmhPC,
        mobile: jnmhPC
      }
    }
  ]
});
export default {
  name: 'app',

  data:function(){
    return {
      pc: true,
    }
  },
  components: {
  },
  router,
  created() {
    this.getURL1();
    if (location.pathname == ''){
      location.pathname = '/new_yearM';
    }
  },
  mounted() {


  },
  methods: {
    getURL1: function () {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.pc = !this.pc;
      }
    },
  },
}
</script>

<style>
#app {
  color: #2c3e50;
}
</style>
